import React from 'react'
import MainLayout from '../layout/MainLayout'

function ResetPassword() {

    const handleSubmit = (e) => {
        alert('not implemented yet. please be patient')
    }

    return (
        <div>
            <MainLayout>
                <div className="registration-page">

                    <h1>Password Reset</h1>
                    <p>Enter your username and we'll send you a link to reset your password.</p>
                    <form action={handleSubmit}>
                        <input type="username"></input>
                        <br />
                        <input type="submit" />

                    </form>

                </div>

            </MainLayout>

        </div>
    )
}

export default ResetPassword
